import type { EventoDaFicha } from '../../api/cliente.js';

const FORMATO = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'America/Sao_Paulo',
});

/**
 * Trilha de auditoria da ficha. É o que responde "quem gerou esse link?" e
 * "quando o comitê decidiu?" meses depois, sem depender da memória de ninguém.
 */
export function LinhaDoTempo({ eventos }: { eventos: EventoDaFicha[] }) {
  if (eventos.length === 0) {
    return <div className="aguardando">Nada registrado ainda.</div>;
  }

  return (
    <ul className="linha-do-tempo">
      {eventos.map((evento) => (
        <li key={evento.eventoId}>
          {evento.resumo}
          <span className="quando">
            {FORMATO.format(new Date(evento.ocorridoEm))} · {evento.autor}
          </span>
        </li>
      ))}
    </ul>
  );
}
